import React from 'react';
import { createRoot } from 'react-dom/client';
import PredictionsLayout from '../components/predictions/PredictionsLayout.jsx';
import AboutPage from '../components/predictions/AboutPage.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <PredictionsLayout>
    <AboutPage />
  </PredictionsLayout>
);
